/* tslint:disable */
/* eslint-disable */
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { PhaseDisplayModel as AceXFoundPortalCoreCaqModelsPhaseDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/phase-display-model';
import { SchwerpunktDisplayModel as AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/schwerpunkt-display-model';
import { GlobalEnumsAceAntragstellungerfolgtfuer as AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-antragstellungerfolgtfuer';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode as AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-ausschreibung-ace-ausschreibung-enums-ace-ausschreibung-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';
import { PhaseDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup } from '@/api/model-index';
import { SchwerpunktDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup } from '@/api/model-index';

export interface IAusschreibungDisplayModel {
  antragstellungFuer?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer;
  ausschreibungsNummer?: null | string;
  ausschreibungsStatus?: AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode;
  date?: null | string;
  dateFrom?: null | string;
  dateTo?: null | string;
  fristFuerBegutachtung?: null | string;
  goalDescription?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  logo?: null | string;
  name?: null | string;
  phase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  portalObject?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  schwerpunkt?: AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModel;
  unterlagenVorhanden?: boolean;
}
export class AusschreibungDisplayModel extends BaseModel implements IAusschreibungDisplayModel {
  antragstellungFuer?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragstellungerfolgtfuer;
  ausschreibungsNummer?: null | string;
  ausschreibungsStatus?: AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode;
  date?: null | string;
  dateFrom?: null | string;
  dateTo?: null | string;
  fristFuerBegutachtung?: null | string;
  goalDescription?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  logo?: null | string;
  name?: null | string;
  phase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  portalObject?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  schwerpunkt?: AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModel;
  unterlagenVorhanden?: boolean;
}
class BaseAusschreibungDisplayModelFormGroup extends FormGroup {
  private static _instance: AusschreibungDisplayModelFormGroup;
  
  public static get Instance(): AusschreibungDisplayModelFormGroup {
    this._instance = new AusschreibungDisplayModelFormGroup({
      antragstellungFuer: new FormControl(null),
      ausschreibungsNummer: new FormControl(null),
      ausschreibungsStatus: new FormControl(null),
      date: new FormControl(null),
      dateFrom: new FormControl(null),
      dateTo: new FormControl(null),
      fristFuerBegutachtung: new FormControl(null),
      goalDescription: new FormArray([]),
      logo: new FormControl(null),
      name: new FormControl(null),
      phase: AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup.Instance,
      portalObject: new FormControl(null),
      schwerpunkt: AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup.Instance,
      unterlagenVorhanden: new FormControl(null),
    });

    return this._instance;
  }
}


export class AusschreibungDisplayModelFormGroup extends BaseAusschreibungDisplayModelFormGroup {
  public get AntragstellungFuer(): FormControl {
    return this.controls["antragstellungFuer"] as FormControl;
  }
  public get AusschreibungsNummer(): FormControl {
    return this.controls["ausschreibungsNummer"] as FormControl;
  }
  public get AusschreibungsStatus(): FormControl {
    return this.controls["ausschreibungsStatus"] as FormControl;
  }
  public get Date(): FormControl {
    return this.controls["date"] as FormControl;
  }
  public get DateFrom(): FormControl {
    return this.controls["dateFrom"] as FormControl;
  }
  public get DateTo(): FormControl {
    return this.controls["dateTo"] as FormControl;
  }
  public get FristFuerBegutachtung(): FormControl {
    return this.controls["fristFuerBegutachtung"] as FormControl;
  }
  public get GoalDescription(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["goalDescription"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Logo(): FormControl {
    return this.controls["logo"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get Phase(): AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup {
    return this.controls["phase"] as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup;
  }
  public get PortalObject(): FormControl {
    return this.controls["portalObject"] as FormControl;
  }
  public get Schwerpunkt(): AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup {
    return this.controls["schwerpunkt"] as AceXFoundPortalCoreCaqModelsSchwerpunktDisplayModelFormGroup;
  }
  public get UnterlagenVorhanden(): FormControl {
    return this.controls["unterlagenVorhanden"] as FormControl;
  }
  

}

export module AusschreibungDisplayModelForm
  {
    export class FormFields
    {
      static _antragstellungFuer: string = "antragstellungFuer";
      static _ausschreibungsNummer: string = "ausschreibungsNummer";
      static _ausschreibungsStatus: string = "ausschreibungsStatus";
      static _date: string = "date";
      static _dateFrom: string = "dateFrom";
      static _dateTo: string = "dateTo";
      static _fristFuerBegutachtung: string = "fristFuerBegutachtung";
      static _goalDescription: string = "goalDescription";
      static _logo: string = "logo";
      static _name: string = "name";
      static _phase: string = "phase";
      static _portalObject: string = "portalObject";
      static _schwerpunkt: string = "schwerpunkt";
      static _unterlagenVorhanden: string = "unterlagenVorhanden";
    }
  }

